<div class="selected-round round-card content-between mt-10 w-90 margin-auto"
  [ngClass]="isMobile ? 'w-90 margin-auto flex-col gap-20' : 'w-full flex-row gap-40'">
  <div class="flex-col">
    <div class="flex-row align-items-start gap-20 " [ngClass]="isMobile ? '' : 'mb-20'">
      <img src="assets/list-icon.svg" alt="list-icon" class="icon" width="40px">
      <div [ngClass]="isMobile ? 'flex-row gap-5' : 'flex-col'">
        <p class="no-margin dark-blue">{{electionSelected + 1}} <sup
            style="top: -4px; left: -2px; font-size: 10px;">{{electionSelected === 0 ?
            'ère' : 'ème'}}</sup> élection</p>
        <p class="no-margin dark-blue bold">{{rounds[electionSelected].title}}</p>
      </div>
    </div>
  </div>
  <div>
    <div class="flex-row gap-10" *ngFor="let candidate of rounds[electionSelected].questions[0].answers; let i = index">
      <div class="candidate-card flex-col
          w-full content-between mb-10">
        <div class="flex-row gap-20">
          <!-- <img src="assets/candidate-icon.svg" alt="candidate-icon" class="icon"> -->
          <div class="flex-col">
            <button style="width: 230px !important;"
              class="no-margin dark-blue bold candidate-button text-left flex-row content-between align-items-center"
              (click)="setActiveList(i)">
              <span class="flex align-items-center gap-10">
                <img
                  *ngIf="rounds[electionSelected].displayedQuestions[0].listImages[i] != undefined && rounds[electionSelected].displayedQuestions[0].listImages[i] !== ''"
                  src="{{rounds[electionSelected].displayedQuestions[0].listImages[i]}}" alt="list-icon" class="icon"
                  width="40px">

                <p class="no-margin">
                  {{candidate}}</p>
              </span>
              <img *ngIf="i != rounds[electionSelected].questions[0].answers.length - 1"
                src="assets/candidates-mixed.svg" alt="list-icon" class="icon" width="15px">

            </button>
          </div>
        </div>
      </div>
      <button
        *ngIf="rounds[electionSelected].displayedQuestions[0].listLink[i] != null && rounds[electionSelected].displayedQuestions[0].listLink[i].length > 0 && i != rounds[electionSelected].questions[0].answers.length - 1"
        class="icon-button mb-10">
        <a href="{{rounds[electionSelected].displayedQuestions[0].listLink[i]}}" class="dark-blue" target="_blank"
          rel="noopener noreferrer" style="text-decoration: underline;" (click)="$event.stopPropagation()">
          <img src="assets/clip.svg" alt="list-icon" class="icon" width="15px">
        </a>
      </button>
    </div>

    <p class="dark-blue no-margin text-sm text-center pointer mt-40" (click)="setActiveElection(-1)">Annuler</p>
  </div>
</div>